import axios from 'axios';

export const getLatestScorecardConfig = async () => {
  const response = await axios.get('admin/tearsheet-scorecard-config/latest');
  return response.data;
};

export const listScorecardConfigVersions = async () => {
  const response = await axios.get('admin/tearsheet-scorecard-config/versions');
  return response.data;
};

export const getScorecardConfigVersion = async (version) => {
  const response = await axios.get(
    `admin/tearsheet-scorecard-config/versions/${version}`
  );
  return response.data;
};

export const createScorecardConfigVersion = async (body) => {
  const response = await axios.post(
    'admin/tearsheet-scorecard-config',
    body
  );
  return response.data;
};
